export const MAX_DOWNLOAD_FILE_NAME_LENGTH = 20

// Characters illegal in file names on common platforms. Whitespace (including
// newlines and tabs) is handled separately by the \s collapse in toSafeFileName.
const ILLEGAL_FILE_NAME_CHARS = /[\\/:*?"<>|]+/g

/**
 * Turns arbitrary text into a safe, bounded download file name.
 *
 * Some items carry very long, unconstrained titles — e.g. a TTS item's `title`
 * is its full transcript, which can be hundreds/thousands of characters and may
 * contain path separators or line breaks. Using that verbatim as a download
 * name produces an invalid or absurdly long file name. This strips the
 * characters that are illegal in file names, collapses whitespace, truncates to
 * a sane length, and falls back when the result is empty.
 */
export const toSafeFileName = (
  name: string | undefined | null,
  fallback = 'download'
): string => {
  const cleaned = (name ?? '')
    .replace(ILLEGAL_FILE_NAME_CHARS, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, MAX_DOWNLOAD_FILE_NAME_LENGTH)
    .trim()

  return cleaned || fallback
}
